export function useDownload() {
    function downloadBlob(response, fileName, type) {
        const blob = new Blob([response.data], { type });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
    }
    return {
        downloadBlob
    }
}